export default __webpack_public_path__ + "static/media/strapi-logo.07abd775.svg";